<nz-header>
  <div class="app-header">
    <div class="logo" (click)="visibleMenuSwitcher = true">
      <img src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20448%20512'%20width='30'%20height='30'%3e%3cpath%20d='M0%2096C0%2078.3%2014.3%2064%2032%2064l384%200c17.7%200%2032%2014.3%2032%2032s-14.3%2032-32%2032L32%20128C14.3%20128%200%20113.7%200%2096zM0%20256c0-17.7%2014.3-32%2032-32l384%200c17.7%200%2032%2014.3%2032%2032s-14.3%2032-32%2032L32%20288c-17.7%200-32-14.3-32-32zM448%20416c0%2017.7-14.3%2032-32%2032L32%20448c-17.7%200-32-14.3-32-32s14.3-32%2032-32l384%200c17.7%200%2032%2014.3%2032%2032z'%20fill='white'/%3e%3c/svg%3e" alt="hamburger menu icon" width="30" height="30">
    </div>

    <div class="header-right">
      <div class="environment-badge" *ngIf="environmentName != 'Production'">
        <span class="env-icon">🚀</span>
        <span class="env-name">{{environmentName}}</span>
      </div>

      <div class="user-dropdown" nz-dropdown [nzDropdownMenu]="userMenu" nzTrigger="click" nzPlacement="bottomRight">
        <div class="user-icon">
          <img src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20448%20512'%20width='30'%20height='30'%3e%3cpath%20d='M224%20256A128%20128%200%201%200%20224%200a128%20128%200%201%200%200%20256zm-45.7%2048C79.8%20304%200%20383.8%200%20482.3C0%20498.7%2013.3%20512%2029.7%20512l388.6%200c16.4%200%2029.7-13.3%2029.7-29.7C448%20383.8%20368.2%20304%20269.7%20304l-91.4%200z'%20fill='white'/%3e%3c/svg%3e" alt="user profile icon" width="30" height="30">
          <i nz-icon nzType="down" nzTheme="outline" class="dropdown-arrow"></i>
        </div>
      </div>
    </div>

    <nz-dropdown-menu #userMenu="nzDropdownMenu">
      <div class="user-dropdown-content">
        <div class="user-info">
          <div class="user-avatar">
            <img src="/public/svg-icons/account-avatar-multimedia.svg" alt="user avatar">
          </div>
          <div class="user-details">
            <div class="user-name">{{fullname}}</div>
            <div class="user-email">{{username}}</div>
          </div>
        </div>
        <div class="dropdown-divider"></div>
        <div class="dropdown-item" (click)="logout()">
          <i nz-icon nzType="logout" nzTheme="outline"></i>
          <span>Sign Out</span>
        </div>
      </div>
    </nz-dropdown-menu>
  </div>
</nz-header>

<nz-drawer
  [nzClosable]="true"
  [nzVisible]="visibleMenuSwitcher"
  nzPlacement="left"
  [nzTitle]="'Horizon Portal'"
  (nzOnClose)="visibleMenuSwitcher = false">
  
  <div *nzDrawerContent>
    <app-menu (isMenuOpened)="onMenuClosed($event)"></app-menu>
  </div>
</nz-drawer>